import React from 'react';
import { useLanguage } from '../context/LanguageContext';
export function TestimonialsSection() {
  const {
    t
  } = useLanguage();
  const testimonials = t.testimonials.items;
  return <section className="w-full bg-[#f8f9fa] py-24" data-id="element-129">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-130">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-131">
          <h2 className="text-3xl lg:text-4xl font-poppins font-bold text-navy mb-4" data-id="element-132">
            {t.testimonials.heading}
          </h2>
          <p className="text-gray-500 text-lg" data-id="element-133">{t.testimonials.subtitle}</p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-134">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white border border-borderColor rounded-xl p-8 relative overflow-hidden flex flex-col justify-between min-h-[200px]" data-id="element-135">
              {/* Decorative Quote Mark */}
              <div className="absolute top-6 right-6 text-brandOrange/20 font-serif text-8xl leading-none select-none pointer-events-none" data-id="element-136">
                "
              </div>

              <p className="text-navy text-lg font-medium leading-relaxed mb-8 relative z-10 pr-12" data-id="element-137">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-4 relative z-10 border-t border-gray-100 pt-6" data-id="element-138">
                <div className="w-10 h-10 rounded-full bg-navy flex items-center justify-center text-white font-bold text-sm shrink-0" data-id="element-139">
                  {testimonial.initials}
                </div>
                <span className="text-gray-500 text-sm font-medium" data-id="element-140">
                  {testimonial.role}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}